module.exports = __webpack_public_path__ + "static/cartoon-dffc9546936ff57e18c16df3aba5651a.png";